import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoldPriceService {

  url = environment.serverAPI + '/api';

  constructor(private http: HttpClient
  ) { }


  getGoldMetalApi(metalType: string): Observable<Object> {
    return this.http.get(`${this.url}/catalog/gold/rate?metal=${metalType}`);
  }

  getAllMetalRatesDropDown(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/catalog/gold/rate/all`);
  }


}
